import React from 'react';
import './About.css';
import { FaCheckCircle } from 'react-icons/fa';

const About = () => {
  const highlights = [
    'Cloud-based dengan akses dari mana saja, kapan saja',
    'Auto-sync dengan accounting software (Jurnal, Accurate, QuickBooks)',
    'Support multi-user dan multi-role dengan permission control',
    'Mobile app untuk monitoring on-the-go'
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <span className="section-label">TENTANG ORION BILLING</span>
            <h2 className="section-title">Billing System yang Dirancang untuk Bisnis Indonesia</h2>
            <p className="about-description">
              Orion Billing System adalah solusi modern untuk mengelola invoice, tagihan, dan pembayaran pelanggan. 
              Dikembangkan khusus untuk memahami kebutuhan bisnis di Indonesia, dari startup hingga enterprise.
            </p>
            <p className="about-description">
              Dengan interface yang user-friendly dan fitur automation yang powerful, kami membantu bisnis menghemat waktu, 
              meningkatkan cash flow, dan mengurangi kesalahan dalam proses billing. Fokus pada pertumbuhan bisnis Anda, 
              biarkan Orion yang urus administratif billing.
            </p>
            
            <div className="about-highlights">
              {highlights.map((highlight, index) => (
                <div key={index} className="highlight-item">
                  <FaCheckCircle className="check-icon" />
                  <span>{highlight}</span>
                </div>
              ))}
            </div>

            <a href="#contact" className="btn-primary">Mulai Free Trial</a>
          </div>

          <div className="about-image">
            <div className="image-placeholder">
              <div className="placeholder-content">
                <h3>ORION</h3>
                <p>Billing System</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
